import * as React from 'react';
import * as ReactDOM from 'react-dom';

import SelectField from 'material-ui/SelectField';

import {
  activeSelectFieldBox,
  errorSelectFieldBox,
  selectFieldBox,
} from '../../../../client/styles/input.style';

// imported interfaces are considered not used: https://github.com/eslint/typescript-eslint-parser/issues/223
// eslint-disable-next-line no-unused-vars
import { SelectFieldInputProps, SelectFieldInputState } from '../Inputs/types';

class SelectFieldInput extends React.Component<
  SelectFieldInputProps,
  SelectFieldInputState
> {
  constructor(props: SelectFieldInputProps) {
    super(props);
    this.state = {
      focused: false,
    };
  }

  selectRef = null as any;

  onFocus = () => {
    this.setState({ focused: true });
  };

  onBlur = () => {
    this.setState({ focused: false });
    this.props.onBlur(this.props.id);
  };

  onChange = (event: Object, index: number, value: string): void => {
    this.props.onChange(this.props.id, value);
    // Animation is 450ms; 500ms focus delay so that animation can finish.
    setTimeout(this.focusButton, 500);
  };

  focusButton = () => {
    // I figured using a ref would be better than document.getElementById(this.props.id);
    const ele = ReactDOM.findDOMNode(this.selectRef) as Element;
    if (ele) {
      const button = ele.getElementsByTagName('button')[0];
      if (button) {
        button.focus();
      }
    }
  };

  setRef = (ref: any) => {
    this.selectRef = ref;
  };

  render() {
    const {
      id,
      input,
      inputBoxStyle,
      showError,
      floatingLabelText,
    } = this.props;
    const { focused } = this.state;

    let boxStyle;

    if (focused) {
      boxStyle = activeSelectFieldBox;
    } else if (showError) {
      boxStyle = errorSelectFieldBox;
    } else {
      boxStyle = selectFieldBox;
    }

    if (inputBoxStyle) {
      boxStyle.style = { ...boxStyle.style, ...inputBoxStyle };
    }

    return (
      <SelectField
        id={id}
        dropDownMenuProps={{
          anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
        }}
        floatingLabelText={floatingLabelText}
        fullWidth
        onBlur={this.onBlur}
        onChange={this.onChange}
        onFocus={this.onFocus}
        ref={this.setRef}
        value={input}
        {...boxStyle}
      >
        {this.props.children}
      </SelectField>
    );
  }
}

export default SelectFieldInput;
